import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {HOSTS_CONFIG} from "src/constants";
import Backend from "i18next-http-backend";
import _ from "lodash";

const hostname = window.location.hostname;
const localeUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCALES_URL : "https://" + hostname + "/locales";

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: _.get(HOSTS_CONFIG, `${hostname}`).supportedLanguages,
        fallbackLng: _.get(HOSTS_CONFIG, `${hostname}`).defaultLanguage,
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "language"
        },
        backend: {
            loadPath: localeUrl + "/{{lng}}/{{ns}}.json"
            //crossDomain: true
        }
    });

export default i18next;
